import moment from 'moment';

const SCHEDULE_DATE_NO_TIME_NAME = 'scheduleDateForm';
const SCHEDULE_DATE_AND_TIME_NAME = 'scheduleDateTimeForm';

const getAvailableRangeDates = activity => {
  if (!activity) {
    return {
      startDate: null,
      endDate: null,
      daysOfWeek: []
    };
  }

  const schedule =
    activity[SCHEDULE_DATE_NO_TIME_NAME] ||
    activity[SCHEDULE_DATE_AND_TIME_NAME];

  if (!schedule) {
    return {
      startDate: null,
      endDate: null,
      daysOfWeek: []
    };
  }

  const daysOfWeek = [];

  if (activity[SCHEDULE_DATE_NO_TIME_NAME]) {
    const days = getAvailableDaysOfWeekList(schedule.days);
    daysOfWeek.push(...days);
  } else if (activity[SCHEDULE_DATE_AND_TIME_NAME]) {
    schedule.daysArray.map(item => {
      const days = getAvailableDaysOfWeekList(item.days);
      daysOfWeek.push(...days);
    });
  }

  const availability = schedule.availability || {};

  return {
    startDate: availability.startDate,
    endDate: availability.endDate,
    daysOfWeek: daysOfWeek
  };
};

const getAvailableDaysOfWeekList = days => {
  return Object.keys(days || {})
    .filter(field => days[field])
    .map(item => item);
};

const getDisabledDates = (
  availableParticipantsData,
  initialStartingDate,
  activity
) => {
  const availableParticipantsPerDate = availableParticipantsData
    ? availableParticipantsData.activities[0].availableParticipantsPerDate
    : [];

  const schedule = activity && activity[SCHEDULE_DATE_AND_TIME_NAME];

  return availableParticipantsPerDate
    .filter(item => {
      if (initialStartingDate && item.date) {
        if (initialStartingDate.startDate && initialStartingDate.endDate) {
          if (
            moment(item.date, 'YYYY-MM-DD').isBetween(
              initialStartingDate.startDate,
              initialStartingDate.endDate,
              'day',
              '[]'
            )
          ) {
            return false;
          }
        }
        if (
          moment(initialStartingDate).isSame(moment(item.date, 'YYYY-MM-DD'))
        ) {
          return false;
        }
      }
      if (item.startTime && !item.availableParticipants) {
        const bookedDayName = moment(item.date, 'YYYY-MM-DD').format('ddd');
        let isDisabled = true;

        if (schedule) {
          // eslint-disable-next-line array-callback-return
          schedule.daysArray.map(scheduleItem => {
            const days = getAvailableDaysOfWeekList(scheduleItem.days);

            if (days.includes(bookedDayName)) {
              const timesLength = scheduleItem.startTimeAndDuration.length;
              if (timesLength > 1) {
                const bookingsForDay = availableParticipantsPerDate.filter(
                  dateData =>
                    dateData.date === item.date &&
                    !dateData.availableParticipants
                );
                if (bookingsForDay.length !== timesLength) {
                  isDisabled = false;
                }
              }
            }
          });
        }

        return isDisabled;
      }
      return !item.startTime && !item.availableParticipants;
    })
    .map(item => item.date);
};

const getListOfStartTimeAndDuration = (
  availableParticipantsPerDate,
  activity,
  bookActivityForm
) => {
  if (!activity) return [];

  const schedule = activity[SCHEDULE_DATE_AND_TIME_NAME];
  const selectedDate = bookActivityForm.values.startingDate || null;
  const startTimeAndDurationList = [];
  const formattedSelectedDate = selectedDate
    ? moment(selectedDate).format('YYYY-MM-DD')
    : null;

  const availableParticipants = availableParticipantsPerDate
    .filter(item => item.date === formattedSelectedDate)
    .map(item => {
      return {
        ...item,
        startTime: moment(item.startTime, 'HH:mm:ss').format('HH:mm')
      };
    });

  if (!schedule) return [];

  schedule.daysArray.map(item => {
    const days = getAvailableDaysOfWeekList(item.days);
    const dayOfSelectedDate = moment(selectedDate).format('ddd');

    if (selectedDate && days.includes(dayOfSelectedDate)) {
      item.startTimeAndDuration.map(item => {
        const startTime = moment(item.startTime).format('HH:mm');

        const seatsLeftObj = availableParticipants.find(
          item => item.startTime === startTime
        );

        const seatsLeft = seatsLeftObj
          ? seatsLeftObj.availableParticipants
          : activity.generalForm.maxParticipants;

        startTimeAndDurationList.push({
          id: `${startTime}-${item.duration}-${item.timeType}`,
          startTime: startTime,
          seatsLeft: parseInt(seatsLeft),
          maxParticipants: activity.generalForm.maxParticipants,
          duration: item.duration,
          timeType: item.timeType
        });
      });
    }
  });

  return startTimeAndDurationList;
};

const getDefaultStartTime = (startTimeAndDurationList, bookActivityForm) => {
  const startTime = bookActivityForm.values.startTime;
  let defaultStartTime = null;

  if (!startTimeAndDurationList.length) {
    return defaultStartTime;
  }

  defaultStartTime = startTimeAndDurationList[0];

  if (startTime) {
    const existedStartTime = startTimeAndDurationList.find(
      item => item.id === startTime.id
    );
    if (existedStartTime) defaultStartTime = existedStartTime;
  }

  return defaultStartTime;
};

const getListOfStartTimeAndDurationByCutoffPeriod = (
  activity,
  listOfStartTimeAndDuration,
  startingDate
) => {
  const cutoffData = activity[activity.scheduleType];

  if (
    !listOfStartTimeAndDuration ||
    !listOfStartTimeAndDuration.length ||
    !cutoffData ||
    !startingDate
  ) {
    return listOfStartTimeAndDuration;
  }

  const cutoffPeriod = parseInt(cutoffData.cutoffPeriod);
  const cutoffPeriodTimeType = cutoffData.cutoffPeriodTimeType;

  return listOfStartTimeAndDuration
    .map(item => {
      const startTime = moment(item.startTime, 'HH:mm');
      const dateWithTime = moment(startingDate).set({
        hour: startTime.get('hour'),
        minute: startTime.get('minute')
      });
      const nowCutoffDate = moment().add(cutoffPeriod, cutoffPeriodTimeType);
      const difference = moment(dateWithTime).diff(nowCutoffDate);

      if (difference <= 0) {
        return false;
      }

      return item;
    })
    .filter(item => item);
};

export {
  getAvailableRangeDates,
  getAvailableDaysOfWeekList,
  getDisabledDates,
  getListOfStartTimeAndDuration,
  getDefaultStartTime,
  getListOfStartTimeAndDurationByCutoffPeriod
};
